import React from "react";
import { useStopwatch } from "react-timer-hook";

const Timer = () => {
    const { seconds, minutes, hours } = useStopwatch({ autoStart: true });
    return (
      <div style={{ textAlign: "center" }} className="mt-3">
        <span>
          {hours === 0 ? "0" : ""}
          {hours}
        </span>
        :
        <span>
          {minutes === 0 ? "0" : ""}
          {minutes}
        </span>
        :
        <span>
          {seconds < 10 ? "0" : ""}
          {seconds}
        </span>
      </div>
    );
  };

  export default Timer;